var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirCoolerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    viewBox: "0 0 64 64",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,39A13,13,0,1,0,19,26,13.015,13.015,0,0,0,32,39Zm-6.3-4h12.61A10.938,10.938,0,0,1,25.7,35Zm14.784-2H23.521a11.013,11.013,0,0,1-1.307-2H41.786A11.013,11.013,0,0,1,40.479,33Zm2.47-8h-21.9a10.9,10.9,0,0,1,.375-2H42.574A10.9,10.9,0,0,1,42.949,25Zm0,2a10.9,10.9,0,0,1-.375,2H21.426a10.9,10.9,0,0,1-.375-2ZM38.305,17H25.7a10.938,10.938,0,0,1,12.61,0ZM23.521,19H40.479a11.013,11.013,0,0,1,1.307,2H22.214A11.013,11.013,0,0,1,23.521,19Z",
    fill: "current",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11,47a5.006,5.006,0,0,0,5,5h.246l1.243,4.352A3.667,3.667,0,0,0,21,59h1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V59h8v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V59h1a3.667,3.667,0,0,0,3.511-2.648L47.754,52H48a5.006,5.006,0,0,0,5-5V27a5.009,5.009,0,0,0-4-4.9V5a4,4,0,0,0-4-4H19a4,4,0,0,0-4,4V22.1A5.009,5.009,0,0,0,11,27ZM26,61H24V59h2Zm14,0H38V59h2Zm4.588-5.2A1.659,1.659,0,0,1,43,57H21a1.659,1.659,0,0,1-1.588-1.2L18.326,52H45.674ZM17,5a2,2,0,0,1,2-2H45a2,2,0,0,1,2,2V39a2,2,0,0,1-2,2H19a2,2,0,0,1-2-2ZM13,27a3,3,0,0,1,2-2.816V39a4,4,0,0,0,4,4H45a4,4,0,0,0,4-4V24.184A3,3,0,0,1,51,27V47a3,3,0,0,1-3,3H16a3,3,0,0,1-3-3Z",
    fill: "current",
    className: "color000 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 11a3 3 0 10-3-3A3 3 0 0042 11zm0-4a1 1 0 11-1 1A1 1 0 0142 7zM34 11a3 3 0 10-3-3A3 3 0 0034 11zm0-4a1 1 0 11-1 1A1 1 0 0134 7z",
    fill: "current",
    className: "color000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirCoolerIcon);
export default __webpack_public_path__ + "static/media/air-cooler-icon.d5f6edae1f77bdc6cf8a09c3063ad532.svg";
export { ForwardRef as ReactComponent };